import { Outlet } from 'react-router-dom';

import { ADMIN_PATH, AdminLayout } from '@/features/admin';
import { GuardAuthenticated } from '@/features/auth';
import { UserType } from '@/services/api';

export function AdminAuthenticatedLayout() {
  return (
    <GuardAuthenticated
      authorizations={[UserType.CompanyAdmin, UserType.SharedInterview]}
      loginPath={`${ADMIN_PATH}/login`}
    >
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </GuardAuthenticated>
  );
}
